import { useEffect, useState } from "react";
import api from "../services/api";

const parseNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? Math.round(numberValue) : null;
};

const normalizeWeather = (payload = {}) => {
  const source = payload.weather || payload.current || payload;
  const location = payload.location || source.location || {};

  return {
    available: Boolean(payload.available),
    tempC: parseNumber(source.tempC ?? source.temperatureC ?? source.temp),
    condition:
      source.condition || source.summary || source.description || null,
    city: source.city || location.city || payload.city || null,
    state: source.state || location.state || payload.state || null,
    iconKey: source.iconKey || source.icon || payload.iconKey || null,
  };
};

const useDashboardWeather = (companyId) => {
  const [loading, setLoading] = useState(false);
  const [weather, setWeather] = useState({ available: false });

  useEffect(() => {
    if (!companyId) {
      setWeather({ available: false });
      setLoading(false);
      return;
    }

    let mounted = true;

    const fetchWeather = async () => {
      setLoading(true);
      try {
        const response = await api.get("/dashboard/weather", {
          params: { companyId },
        });
        if (!mounted) return;
        setWeather(normalizeWeather(response?.data));
      } catch (error) {
        if (!mounted) return;
        setWeather({ available: false });
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchWeather();

    return () => {
      mounted = false;
    };
  }, [companyId]);

  return { weather, loading };
};

export default useDashboardWeather;
